import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const assetRegisterConditionData = api(async function assetRegisterConditionData(params) {
    const registerId = params?.registerId
    if (!registerId) return null
    return query(
        gql`
            query GetAssetRegisterConditionData($registerId: String!) {
                assetRegisterConditionData(registerId: $registerId) {
                    assetRegisterFields {
                        field
                        label
                        values
                        isCustom
                    }
                }
            }
        `,
        { registerId },
        { returns: "assetRegisterConditionData" }
    )
})
